// Number
export const currencyRound = (value: number | string) => Math.round(Number(value) * 100) / 100;
